export default __webpack_public_path__ + "static/media/phone.a92e8ec1.png";